import { Text } from "../../../../../text";
import { OptionLabelProps } from "./types";
import styles from "./styles.module.scss";

export const OptionLabel = ({
  label,
  dataTestId,
  searchValue,
}: OptionLabelProps) => {
  if (searchValue) {
    const searchValueRegExp = new RegExp(`(${searchValue})`, "gi");
    const highlightedMatchesInLabel = label.replace(
      searchValueRegExp,
      (match) =>
        `<span class="${
          styles["match-substring"]
        }" data-test-id="${dataTestId}-match-substring">${match.replace(
          /</g,
          "&lt;"
        )}</span>`
    );

    return (
      <Text className={styles.multiline} dataTestId={`${dataTestId}-label`}>
        <span dangerouslySetInnerHTML={{ __html: highlightedMatchesInLabel }} />
      </Text>
    );
  }

  return (
    <Text className={styles.multiline} dataTestId={`${dataTestId}-label`}>
      {label}
    </Text>
  );
};
